import { atom } from "jotai";

const Theme = atom("dark");
const Playing = atom(false);
const FirstBlockVisible = atom(true);
const SoicalHover = atom(false);

export { Theme, Playing, FirstBlockVisible, SoicalHover };
